import { Button } from 'primereact/button';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';

import { FreshShipmentActions } from '@/app/slices/freshShipment';
import { RootState } from '@/app/store';
import usePageTitle from '@/components/hooks/usePageTitle';
import { TOA_GetFreshShipmentShipGroups } from '@/types.gql';
import { formatDateWithPattern, sanitizeForUrl } from '@/utils';

type ShipmentGroupsViewButtonProps = {
  data: TOA_GetFreshShipmentShipGroups;
};
export const ShipmentGroupsViewButton = ({
  data,
}: ShipmentGroupsViewButtonProps) => {
  const { setTitle } = usePageTitle();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { qcLoaded, isCsr } = useSelector(
    (state: RootState) => state.freshShipment,
  );
  const [params] = useSearchParams();

  const date =
    params.get('date') || formatDateWithPattern(new Date(), 'MM-dd-yyyy');
  const siteId = params.get('sId');

  const handleClick = () => {
    setTitle(data?.shipGroupName as string, data?.shipGroupName as string);

    dispatch({
      type: FreshShipmentActions.UPDATE_FRESH_SHIPMENT_GROUPS,
      shipmentGroup: data,
    });
    dispatch({
      type: FreshShipmentActions.UPDATE_SHOW_FORM,
      showForm: true,
    });

    if (data) {
      const currentParams = new URLSearchParams(params);
      const formattedName = sanitizeForUrl(data.shipGroupName || '');

      if (!currentParams.has('group-id')) {
        currentParams.set('group-id', data.shipGroupId as string);
      }

      navigate(`/fresh-shipment/${formattedName}?${currentParams.toString()}`);
    }
  };

  return (
    <div className={`shipment-groups-view-button__wrapper`}>
      {isCsr ? (
        <Button
          onClick={handleClick}
          className="shipment-groups-view-button"
          severity="secondary"
          disabled={!date || !siteId}
        >
          View
        </Button>
      ) : (
        <Button
          onClick={qcLoaded ? () => handleClick() : () => {}}
          className="shipment-groups-view-button"
          severity="secondary"
          disabled={!date || !siteId}
          tooltip={!qcLoaded ? 'Please save QC data first' : undefined}
        >
          View
        </Button>
      )}
    </div>
  );
};
